<ng-container [ngSwitch]="pageDisplayState">

    <!-- Loading spinner -->
    <div *ngSwitchCase="'loading'"
        class="overlay-loader"
        style="left: 58.5%"
    >
        <app-dot-loader-scale></app-dot-loader-scale>
    </div>

    <!-- ThoughtSpot is under maintenence (503) -->
    <app-thoughtspot-service-unavailable *ngSwitchCase="'503'"></app-thoughtspot-service-unavailable>

    <!-- Reports table -->
    <mat-card *ngSwitchCase="'reportsTable'" appearance="outlined">
        <app-reports-list-table></app-reports-list-table>
    </mat-card>

    <!-- Empty state -->
    <mat-card *ngSwitchCase="'empty'" class="m-4" appearance="outlined">
        <app-empty-state [label]="'It looks like there aren’t any reports right now.'"></app-empty-state>
    </mat-card>

</ng-container>
